import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesComissoes {
  ler: boolean;
  atualizar: boolean;
}

/**
 * Espelho, no frontend, do grant real de RBAC do recurso `comissoes`
 * (`apps/api/src/modules/comissoes/comissoes.routes.ts`, seed original
 * da migration `004`): `admin` (curinga `*`) tem tudo; `financeiro` e o
 * papel interno `parceiros` têm só `ler`. `atualizar` (pagar uma
 * comissão) é restrito a `admin` — mesmo nível de restrição de
 * `POST /financeiro/transacoes`. Usado apenas para decidir o que
 * mostrar na UI — a autorização real é sempre revalidada pelo backend.
 */
export function permissoesComissoes(papel: PapelUsuario): PermissoesComissoes {
  if (papel === 'admin') return { ler: true, atualizar: true };
  if (papel === 'financeiro' || papel === 'parceiros') return { ler: true, atualizar: false };
  return { ler: false, atualizar: false };
}
